export const PAGE_FILTER_PARAMS = {
  clientId: 'clientId',
  opportunityId: 'opportunityId',
  productId: 'productId',
  invoiceId: 'invoiceId',
  taskId: 'taskId',
} as const;

export type PageFilterParamKey = keyof typeof PAGE_FILTER_PARAMS;

export function readPageFilterParam(
  search: string,
  key: PageFilterParamKey,
): string | null {
  const value = new URLSearchParams(search).get(PAGE_FILTER_PARAMS[key]);
  if (!value) return null;
  const trimmed = value.trim();
  return trimmed || null;
}

export function buildPageUrl(
  path: string,
  params: Partial<Record<PageFilterParamKey, string | null | undefined>>,
): string {
  const search = new URLSearchParams();
  for (const key of Object.keys(PAGE_FILTER_PARAMS) as PageFilterParamKey[]) {
    const value = params[key];
    if (value) search.set(PAGE_FILTER_PARAMS[key], value);
  }
  const query = search.toString();
  return query ? `${path}?${query}` : path;
}
